import { render, staticRenderFns } from "./PurchaseVatRegimeSelect.vue?vue&type=template&id=88069686&scoped=true"
import script from "./PurchaseVatRegimeSelect.vue?vue&type=script&lang=ts"
export * from "./PurchaseVatRegimeSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88069686",
  null
  
)

export default component.exports